module.exports = __webpack_public_path__ + "static/our-commitment-cta-d848b6504bab0bcaa52cb6b05cfcef2d.png";